// /* global Waypoint */
// Do not delete the above comment, it's a workaround until waypoints resolve their webpack issues.

import { Power0, Power3 } from 'gsap'
import TimelineMax from 'gsap/TimelineMax'

class FiltersNav {
  constructor ($el, isotope) {
    this.$el = $el
    this.isotope = isotope
    // this.infiniteScroll = infiniteScroll
    this.height = $el.height()
    this.isOpen = false
    this.timeline = new TimelineMax()
    this.toggle = this.toggle.bind(this)
    this.selectFilter = this.selectFilter.bind(this)
    this.timelineItems = new TimelineMax()

    this.$checkboxes = this.$el.find('input')
    this.$checkboxes.change(() => {
      // map input values to an array
      const inclusives = []
      // inclusive filters from checkboxes
      this.$checkboxes.each(function (i, el) {
        // if checkbox, use value if checked
        if (el.checked) {
          inclusives.push(el.value)
        }
      })

      // combine inclusive filters
      var filterValue = inclusives.length ? inclusives.join(', ') : '*'
      location.hash = filterValue === '*' ? '' : `filter=${encodeURIComponent(filterValue)}`
    })

    this.onHashChange = this.onHashChange.bind(this)
    $(window).on('hashchange', () => { this.onHashChange(false) })
  }

  onHashChange (instant = false) {
    const hashFilter = this.getHashFilter()
    this.selectFilter(hashFilter, instant)
  }

  /**
   * Gets filter value from location.hash
   */
  getHashFilter () {
    var matches = location.hash.match(/filter=([^&]+)/i)
    if (!matches) {
      return ''
    }
    return decodeURIComponent(matches[1])
  }

  /**
   *
   * @param {string} filter
   * @param {boolean} instant
   */
  selectFilter (filter, instant = false) {
    filter =
      filter
        .split(', ')
        .map((filter) => {
          if (filter === '*' || filter.length === 0) {
            return filter
          } else {
            return `.product_category-${filter}`
          }
        })
        .join(', ')

    const currentItems = this.isotope.getFilteredItemElements()
    const $currentItems = $(currentItems)

    if (instant) {
      this.isotope.arrange({ filter })
      return
    }

    $currentItems.each((i, el) => {
      const $el = $(el)
      const waypoint = $el.data('waypoint')
      if (typeof waypoint !== 'undefined') {
        waypoint.disable()
      }
      $el.data('animateInDone', true)
    })

    this.timelineItems
      .clear()
      .fromTo(
        $currentItems.find('.product-listed__image'),
        0.8,
        { x: '0%' },
        { x: '100%', ease: Power3.easeIn }
      )
      .fromTo(
        $currentItems.find('.bg'),
        0.8,
        { x: '0%' },
        {
          x: '-100%',
          ease: Power3.easeIn,
          onComplete: () => {
            this.isotope.arrange({ filter })
          },
        },
        0
      )

    this.isotope.once('arrangeComplete', (event, laidOutItems) => {
      const currentItems = this.isotope.getFilteredItemElements()
      const $currentItems = $(currentItems)
      this.timelineItems
        .clear()
        .fromTo(
          $currentItems.find('.product-listed__image'),
          0.8,
          { x: '-100%' },
          { x: '0%', ease: Power3.easeOut }
        )
        .fromTo(
          $currentItems.find('.bg'),
          0.8,
          { x: '100%' },
          { x: '0%', ease: Power3.easeOut },
          0
        )
    })
  }

  /**
   *
   */
  toggle () {
    if (!this.isOpen) {
      this.open()
    } else {
      this.close()
    }
  }

  /**
   *
   */
  open () {
    this.isOpen = true
    this.timeline
      .clear()
      .set(
        this.$el,
        { autoAlpha: 1, height: 'auto', y: '0px' }
      )
      .set(
        this.$el.find('ul'),
        { y: '0px' }
      )
      .from(
        this.$el,
        0.6,
        { height: 0, ease: Power3.easeInOut }
      )
      .staggerFromTo(
        this.$el.find('li'),
        0.6,
        { autoAlpha: 0 },
        { autoAlpha: 1, ease: Power0.easeNone },
        0.1,
        0.2
      )
  }

  /**
   *
   */
  close () {
    this.isOpen = false
    this.timeline
      .clear()
      .to(
        this.$el,
        0.6,
        { height: 0, ease: Power3.easeInOut }
      )
      .to(
        this.$el.find('li'),
        0.6,
        { autoAlpha: 0, ease: Power0.easeNone },
        0
      )
  }
}

export default FiltersNav



// WEBPACK FOOTER //
// ./scripts/components/FiltersNav.js